/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMopedIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-moped"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.85 19.3Q6.85 19.3 6.19 19.3Q5.53 19.3 4.61 18.38Q3.7 17.45 3.7 16.15L2.98 16.15Q2.42 16.15 2.04 15.76Q1.65 15.38 1.65 14.82L1.65 12.95Q1.65 11.22 2.89 10.01Q4.13 8.8 5.85 8.8L7.35 8.8Q8.47 8.8 9.24 9.56Q10 10.32 10 11.45L10 13.9L13.45 13.9L16.95 9.5L16.95 6.9Q16.95 6.9 16.95 6.9Q16.95 6.9 16.95 6.9L15.03 6.9Q14.55 6.9 14.22 6.58Q13.9 6.25 13.9 5.78Q13.9 5.3 14.22 4.97Q14.55 4.65 15.03 4.65L17.13 4.65Q17.98 4.65 18.59 5.29Q19.2 5.92 19.2 6.8L19.2 9.38Q19.2 9.82 19.05 10.25Q18.9 10.68 18.63 11.03L15.35 15.15Q14.97 15.63 14.43 15.89Q13.88 16.15 13.28 16.15L10 16.15Q10 17.48 9.09 18.39Q8.18 19.3 6.85 19.3ZM6.85 17.05Q6.85 17.05 7.04 17.05Q7.22 17.05 7.49 16.79Q7.75 16.52 7.75 16.15L5.95 16.15Q5.95 16.52 6.21 16.79Q6.47 17.05 6.85 17.05ZM8.88 7.95L5.83 7.95Q5.35 7.95 5.03 7.63Q4.7 7.3 4.7 6.83Q4.7 6.35 5.03 6.03Q5.35 5.7 5.83 5.7L8.88 5.7Q9.35 5.7 9.68 6.03Q10 6.35 10 6.83Q10 7.3 9.68 7.63Q9.35 7.95 8.88 7.95ZM19.2 19.3Q19.2 19.3 18.54 19.3Q17.88 19.3 16.96 18.39Q16.05 17.48 16.05 16.15Q16.05 14.82 16.96 13.91Q17.88 13 19.2 13Q20.52 13 21.44 13.91Q22.35 14.82 22.35 16.15Q22.35 17.48 21.44 18.39Q20.52 19.3 19.2 19.3ZM19.2 17.05Q19.2 17.05 19.39 17.05Q19.57 17.05 19.84 16.79Q20.1 16.52 20.1 16.15Q20.1 15.78 19.84 15.51Q19.57 15.25 19.2 15.25Q18.82 15.25 18.56 15.51Q18.3 15.78 18.3 16.15Q18.3 16.52 18.56 16.79Q18.82 17.05 19.2 17.05Z" fill={color} />
    </svg>
  );
}
